var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-tracker"},_vm._l((_vm.availableTypes),function(type){return _c('Vector',{key:type.index,staticClass:"plan-icon",attrs:{"src":_vm.insurance[type].icon.url}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }